import React from 'react';
import { Link } from 'react-router-dom';
import SidebarSection from '~/components/sidebar_section';
import getDateFromISOToLocal from '~/utils/getDateFromISOToLocal';
import { useRecentActivity } from '../providers';
const DetailsPanel = () => {
    const { selectedDocument: selectedActivity } = useRecentActivity();
    const comparisonLink = (`/compare/${selectedActivity === null || selectedActivity === void 0 ? void 0 : selectedActivity.documentComparisonId}${window.location.search}`);
    return (React.createElement(SidebarSection, { title: 'Activity Details', className: 'activity-details-panel-container', "data-testid": 'selected-recent-activity-details', isActive: !!selectedActivity }, selectedActivity
        ? (React.createElement("div", null,
            React.createElement("div", { className: 'line-item' },
                React.createElement("h6", null, "Activity"),
                React.createElement("div", null, selectedActivity.documentComparisonActivityType)),
            React.createElement("div", { className: 'line-item' },
                React.createElement("h6", null, "Comparison Documents"), selectedActivity === null || selectedActivity === void 0 ? void 0 :
                selectedActivity.files.map((file, index) => (React.createElement("div", { key: file.id },
                    React.createElement(Link, { "data-testid": `comparison-document-${index}`, target: '_blank', to: `/document/${file.id}`, className: 'panel-link' },
                        React.createElement("i", { className: 'fas fa-external-link-alt' }),
                        " ",
                        file.name))))),
            React.createElement("div", { className: 'line-item' },
                React.createElement("h6", null, "Date"),
                React.createElement("div", null, getDateFromISOToLocal(selectedActivity.timestamp))),
            React.createElement("div", { className: 'line-item' },
                React.createElement("h6", null, "View Comparison"),
                React.createElement("div", null,
                    React.createElement(Link, { "data-testid": 'comparison-link', className: 'line-item-link', to: comparisonLink }, comparisonLink)))))
        : (React.createElement("div", { className: 'sidebar-section-empty' },
            React.createElement("h6", null,
                React.createElement("i", { className: 'fas fa-mouse-pointer' })),
            React.createElement("div", null, "Click a row for more details.")))));
};
export default DetailsPanel;
